// export const domain = 'https://lab.hzfyu.com'
export const domain = 'https://abc.sfscilab.com'
// export const domain = 'http://cwj.lab.com'



// WEBPACK FOOTER //
// ./src/config.js